import { useWorkspace } from "@/features/Workspace/lib/useWorkspace"
import { useEffect, useCallback } from "react"
import { useDashboard } from "../../lib/useDashboard";
import { isSalesSystemAccount, salesAdministrationDepartments } from '@/features/Auth/lib/salesAccess';
import { useAuth } from '@/features/Auth/lib/useAuth';

/** Для руководителей — только отделы, где role = head (subDepartments). Иначе — все отделы пользователя (myDepartments). */
export const useDashboardDepartment = () => {
  const { departments, myDepartments, subDepartments, loading, error } = useWorkspace();
  const { selectedDepartment, setSelectedDepartment } = useDashboard();
  const { user } = useAuth();
  const systemAccount = isSalesSystemAccount(user);

  const departmentsForSelector = systemAccount
    ? salesAdministrationDepartments(departments)
    : (subDepartments.length > 0 ? subDepartments : myDepartments);
  const storageKey = user?.bx?.bx_user?.bx_id
    ? `dashboardDepartment:${user.bx.bx_user.bx_id}`
    : 'dashboardDepartment';

  useEffect(() => {
    const list = systemAccount
      ? salesAdministrationDepartments(departments)
      : (subDepartments.length > 0 ? subDepartments : myDepartments);
    const localStorageValue = localStorage.getItem(storageKey);
    const departmentExists = list.some(dep => String(dep.id) === localStorageValue);

    if (!localStorageValue || !departmentExists) {
      if (list.length > 0) {
        setSelectedDepartment(String(list[0].id));
        localStorage.setItem(storageKey, String(list[0].id));
      } else {
        setSelectedDepartment(null);
        localStorage.removeItem(storageKey);
      }
    } else {
      setSelectedDepartment(localStorageValue);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [departments, subDepartments, myDepartments, storageKey, systemAccount, setSelectedDepartment]);

  const setValue = useCallback((value: string | null) => {
    setSelectedDepartment(value);
    if (value) {
      localStorage.setItem(storageKey, value);
    } else {
      localStorage.removeItem(storageKey);
    }
  }, [setSelectedDepartment, storageKey]);

  const options = departmentsForSelector.map(dep => ({ value: String(dep.id), label: dep.name }));

  return {
    value: selectedDepartment,
    setValue,
    options,
    loading,
    error,
  };
}
